import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
} from 'apps/shared/scripts/styles/constants';

export const badgeClassName = css({
  background:
    'linear-gradient(to bottom right, #91d8fc, #b164e0 50%, #e64f6e 75%, #ff333e 95%)',
  padding: `4px 16px`,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.EXTRA_BOLD,
  borderRadius: 4,
  color: Colors.White,
  [SMALL_DEVICE_MQ]: {
    padding: `2px 14px`,
    fontSize: 12,
  },
});
